/**
 * This object takes a table and makes it possible to highlight a row by
 * clicking on it.
 *
 * If the table has a tbody element, all rows in the tbody will be affected.
 * If there isn't a tbody, all rows in the table will be affected.
 * "numRowsToSkip" can be specified in the options, indicating to skip the
 * first N rows in the tbody if it exists, else the table.
 *
 * When the HighlightableRowTable is created, it walks the table and prepares
 * the rows, adding css and event listeners.  If rows are dynamically added to
 * the table later, each new row should be passed to the prepareRow() function.
 */
'use strict';

var HighlightableRowsTable = function (tableId, options) {
    this.initialize(tableId, options);
};

HighlightableRowsTable.prototype = {

    _clickedCss: 'hover',
    _highlightListener: function () {
    },
    _lastRowClickedOn: null,
    _highlightEnabled: true,
    _clickEnabled: true,

    /**
     * @param tableId - the ID of the table element
     * @param options - contains the following optional settings:
     *    highlightListener: a function that will be called when
     *            a row is highlighted or unhighlighted.  It will be passed
     *            two arguments, the row element, and a boolean that is true
     *            when highlighted.
     *        clickedCss: the CSS added to a table row iff the box is checked
     */
    initialize: function (tableId, options) {

        var table = document.getElementById(tableId);
        var numRowsToSkip = 0;

        //allow the user to override the defaults, if desired
        if (options) {
            if (options.clickedCss) {
                this._clickedCss = options.clickedCss;
            }

            if (options.highlightListener) {
                this._highlightListener = options.highlightListener;
            }

            if (options.numRowsToSkip) {
                numRowsToSkip = options.numRowsToSkip;
            }
        }

        if (table != null) {
            //skip the header rows, if any, by getting rows from the tbody
            var rowContainer = table.getElementsByTagName('tbody')[0];

            if (rowContainer == null) {
                rowContainer = table;
            }

            var rows = rowContainer.children;

            for (var i = numRowsToSkip; i < rows.length; i++) {
                this.prepareRow(rows[i]);
            }
        }
    },

    /**
     * Note: don't call this function more than once for the same
     * row. It would add multiple listeners to the row, which would
     * step on each other.
     */
    prepareRow: function (row) {
        row.style.cursor = 'default';
        jQuery(row).on('mousedown', function (e) {
            return this._handleRowClick(row, e);
        }.bind(this));
    },


    /**
     * Public mutators to allow enabling/disabling certain behaviors of this
     * object.
     */
    disableHighlighting: function () {
        this._highlightEnabled = false;
        this._removeLastHightlight();
    },

    enableHighlighting: function () {
        this._highlightEnabled = true;

        //re-display the last highlighted row
        if (this._lastRowClickedOn != null) {
            var row = this._lastRowClickedOn;
            this._highlightRow(row);
        }
    },

    disableClickHandler: function () {
        this._clickEnabled = false;
    },

    enableClickHandler: function () {
        this._clickEnabled = true;
    },


    /**
     * Event handler function.
     */
    _handleRowClick: function (row, e) {
        if (!this._clickEnabled) {
            return false;
        }

        this._removeLastHightlight();

        if (row === this._lastRowClickedOn) {
            this._lastRowClickedOn = null;
        }
        else {
            this._highlightRow(row);
        }
    },

    _highlightRow: function (row) {
        this._highlightListener(row, true);
        jQuery(row).addClass(this._clickedCss);
        this._lastRowClickedOn = row;
    },

    _removeLastHightlight: function () {
        if (this._lastRowClickedOn != null) {
            //call the listener
            this._highlightListener(this._lastRowClickedOn, false);
            jQuery(this._lastRowClickedOn).removeClass(this._clickedCss);
        }
    }
};

module.exports = HighlightableRowsTable;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/HighlightableRowsTable.js
// module id = 33
// module chunks = 0